import scrollManager from '../utils/scrollManager'
import withScroll from '../hoc/withScroll'

export default withScroll({
  name: 'header',

  previousScroll: 0,

  ui: {
    btBurger: '[js-burger]',
    navWrapper: '[js-header-nav-wrapper]',
    mainNav: '[js-header-main-nav]',
    'togglePanels[]': '[js-header-toggle-panel]',
    'panel[]': '[js-header-panel]',
    'back[]': '[js-header-back]',
  },

  events: [
    {
      target: 'btBurger',
      on: 'click',
      handle (e) {
        e.preventDefault()
        this.ui.btBurger.classList.toggle('is-active')
        this.ui.btBurger.parentNode.parentNode.classList.toggle('is-open')
        this.el.classList.toggle('is-open')
        this.ui.navWrapper.classList.toggle('is-active')

        this.burgerMenuIsOpen = !this.burgerMenuIsOpen

        this.burgerMenuIsOpen ? scrollManager.stop() : scrollManager.restart()

        // close actions
        if (!this.burgerMenuIsOpen) {
          this.ui.mainNav.classList.remove('is-opened')
          document.querySelectorAll('.panel.is-active').forEach(el => {
            el.classList.remove('is-active')
          })
        }
      },
    },
    {
      target: 'togglePanels',
      on: 'click',
      handle (e) {
        e.preventDefault()
        e.stopPropagation()

        this.openPanel(e.currentTarget.parentNode)
      },
    },
    {
      target: 'back', // only on mobile
      on: 'click',
      handle (e) {
        e.target.closest('[js-header-panel]').classList.remove('is-active')
      },
    },
  ],

  componentDidMount () {
    this.body = document.body
    this.header = this.el
    this.headerHeight = window.innerWidth >= 1280 ? this.el.offsetHeight : this.el.querySelector('.header-mobile').offsetHeight
    this.posYorigin = 0
    this.lastScrollTop = 0

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.headerHeight = window.innerWidth >= 1280 ? this.el.offsetHeight : this.el.querySelector('.header-mobile').offsetHeight
      }, 300)
    })

    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.headerHeight = window.innerWidth >= 1280 ? this.el.offsetHeight : this.el.querySelector('.header-mobile').offsetHeight
      }, 300)
    })

    this.body.addEventListener('click', (e) => {
      if (window.innerWidth >= 1280) {
        this.closeAllPanels()
      }
    })
  },

  onScroll ({ y }) {
    if (y > this.headerHeight) {
      if (!this.el.classList.contains('is-fixed')) {
        this.el.classList.add('is-fixed')

        setTimeout(() => {
          this.el.classList.add('has-transition')
        }, 200)
      }

      if (Math.abs(y - this.previousScroll) >= 10) {
        if (y < this.previousScroll) {
          this.el.classList.add('is-visible')
        } else {
          this.el.classList.remove('is-visible')
        }
      }
    } else {
      if (y > this.previousScroll || y === 0) {
        this.el.classList.remove('is-visible', 'is-fixed', 'has-transition')
      }
    }

    this.previousScroll = y
  },

  openPanel (el) {
    const button = el.querySelector('button')
    const panel = el.querySelector('[js-header-panel]')

    button.classList.toggle('is-active')
    panel.classList.toggle('is-active')

    if (button.classList.contains('is-active')) {
      if (window.innerWidth >= 1280 && this.activePanel && this.activePanel !== panel) this.closePanel(this.activePanel.parentNode)

      this.activePanel = panel
      scrollManager.stop()
      this.el.classList.add('is-open')
    } else {
      this.activePanel = null
      scrollManager.restart()
      this.el.classList.remove('is-open')
    }
  },

  closePanel (el) {
    const button = el.querySelector('button')
    const panel = el.querySelector('[js-header-panel]')
    button.classList.remove('is-active')
    panel.classList.remove('is-active')
    this.el.classList.remove('is-open')

    if (document.querySelector('.search-panel').classList.contains('is-hidden')) {
      scrollManager.restart()
    }
  },

  closeAllPanels () {
    this.ui.panel.forEach(el => {
      if (el.classList.contains('panel--level1')) {
        this.closePanel(el.parentNode)
      }
    })
  },
})
